// src/components/chat/Chat.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTshirt, faCalendarAlt, faImages } from '@fortawesome/free-solid-svg-icons';
import DailyOutfit from './Sections/DailyOutfit';
import EventOutfit from './Sections/EventOutfit';
import CombineWithMine from './Sections/CombineWithMine';
import { useChat } from './hooks/useChat';

function Chat() {
    const {
        activeSection,
        handleSectionChange,
        profileData,
        messages,
        userLooks,
        isButtonVisible,
        email,
        setEmail,
        stage,
        setStage,
        addMessage,
        setProfileData,
        setIsButtonVisible,
        setMessages
    } = useChat();

    return (
        <div className="chat-container">
            <div className="section-content">
                {activeSection === 'daily' && (
                    <DailyOutfit 
                        profileData={profileData}
                        setProfileData={setProfileData}
                        messages={messages.daily}
                        userLooks={userLooks}
                        isButtonVisible={isButtonVisible}
                        setIsButtonVisible={setIsButtonVisible}
                        email={email}
                        setEmail={setEmail}
                        stage={stage}
                        setStage={setStage}
                        addMessage={addMessage}
                        setMessages={setMessages}
                    />
                )}
                {activeSection === 'event' && (
                    <EventOutfit 
                        profileData={profileData}
                        messages={messages.event}
                        userLooks={userLooks}
                        email={email}
                        setMessages={setMessages}
                    />
                )}
                {activeSection === 'combine' && (
                    <CombineWithMine 
                        messages={messages.combine}
                        setMessages={setMessages}
                    />
                )}
            </div>

            <div className="bottom-tab-bar">
                <button 
                    onClick={() => handleSectionChange('daily')} 
                    className={`nav-button ${activeSection === 'daily' ? 'active' : ''}`}
                >
                    <FontAwesomeIcon icon={faTshirt} size="lg" />
                </button>
                <button 
                    onClick={() => handleSectionChange('event')} 
                    className={`nav-button ${activeSection === 'event' ? 'active' : ''}`}
                >
                    <FontAwesomeIcon icon={faCalendarAlt} size="lg" />
                </button>
                <button 
                    onClick={() => handleSectionChange('combine')} 
                    className={`nav-button ${activeSection === 'combine' ? 'active' : ''}`}
                >
                    <FontAwesomeIcon icon={faImages} size="lg" />
                </button>
            </div>
        </div>
    );
}

export default Chat;